//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../../services/reports";
import moment from "moment";
import pointsservice from "../../../../services/points";

const initialState = {
	instances: {}
};

const heatMapTiers = 7;

/////////
//types
export const types = {
	INIT_COMPONENT: "components/weeklyfailureheatmap/INIT_COMPONENT",
	LOAD_DATA: "components/weeklyfailureheatmap/LOAD_DATA",
	SET_COMPONENT_DATA: "components/weeklyfailureheatmap/SET_COMPONENT_DATA"
};

function getHeatMapColor(tier, failCount, passCount) {
	if (failCount === 0 && passCount === 0) {
		// rule didnt run return grey
		return "#ccc";
	}

	switch (tier) {
		case 1:
			return "#63BE7B";
		case 2:
			return "#93CC7D";
		case 3:
			return "#AFD47F";
		case 4:
			return "#CCDC81";
		case 5:
			return "#FBE983";
		case 6:
			return "#FCAC78";
		case 7:
			return "#F8696B";
		default:
			return "#FFFFFF";
	}
}

function initComponent(state, action) {
	const id = action.payload.id;
	const component = action.payload.component;
	//do nothing if it's already init
	if (state.instances.id) {
		return state;
	}
	let componentData = {};
	return { ...state, instances: { ...state.instances, [id]: componentData } };
}

function setComponentData(state, action) {
	const id = action.payload.id;
	const componentData = action.payload.componentData;
	return { ...state, instances: { ...state.instances, [id]: componentData } };
}

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.INIT_COMPONENT: {
				return initComponent(state, action);
			}
			case types.LOAD_DATA: {
				return state;
			}
			case types.SET_COMPONENT_DATA: {
				return setComponentData(state, action);
			}
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.loadData()]);
	},

	/**
	 * 	THIS CHART IS NOW DAILY FAILURES NOT WEEKLY
	 */
	*loadData() {
		yield takeEvery(types.LOAD_DATA, function*({ payload }) {
			const component = payload.component;
			const id = payload.id;
			const fromDate = moment(payload.timePeriod.startDate);
			const toDate = moment(payload.timePeriod.endDate);
			const numDays = toDate.diff(fromDate, "days") + 1;
			const componentData = {
				weeklyFailures: []
			};
			const dailyFailures = yield call(
				reportsservice.GetDailyFailures,
				component.ruleInstanceId,
				fromDate,
				toDate
			);
			if (dailyFailures && dailyFailures.length) {
				let min = Number.MAX_SAFE_INTEGER;
				let max = 0;
				dailyFailures.forEach(weeklyFailure => {
					if (weeklyFailure.failCount < min) {
						min = weeklyFailure.failCount;
					}
					if (weeklyFailure.failCount > max) {
						max = weeklyFailure.failCount;
					}
				});
				let spread = max - min;
				//divide bny the number of tiers EXCEPT in the case where the spread doesnt cover the number of tiers in which case divide by the spread.
				//This is for teh scenarios when the failures are all (almost) even then it will reduce the color range by reducing the tiers to the spread.
				let spreadPerTier = spread === 0 ? 1 : spread / (spread < heatMapTiers ? spread : heatMapTiers);
				dailyFailures.forEach(dailyFailure => {
					let heatMapTier = Math.floor((dailyFailure.failCount - min) / spreadPerTier) + 1;
					//If spread is higher than nuber of tiers Then the hour with max failures will end up with a tier 1 higher than what is available due to rounding.
					//in this case bring the tier back to max
					heatMapTier = heatMapTier > heatMapTiers ? heatMapTiers : heatMapTier;
					let display = moment(dailyFailure.weekStart).format("D/MM");
					componentData.weeklyFailures.push({
						color: getHeatMapColor(heatMapTier, dailyFailure.failCount, dailyFailure.passCount),
						display: display,
						failures: dailyFailure.failCount
					});
				});
			}
			yield put(actions.setComponentData(id, componentData));
			if (payload.onLoadComplete) {
				payload.onLoadComplete();
			}
		});
	}
};

////////
//actions
export const actions = {
	initComponent(id, component) {
		return {
			type: types.INIT_COMPONENT,
			payload: { id, component }
		};
	},
	loadData(id, component, timePeriod, onLoadComplete) {
		return {
			type: types.LOAD_DATA,
			payload: { id, component, timePeriod, onLoadComplete }
		};
	},
	setComponentData(id, componentData) {
		return {
			type: types.SET_COMPONENT_DATA,
			payload: { id, componentData }
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/HeatMaps/DailyFailureHeatMap/redux.js